import React, {Component} from 'react';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import { Cookies } from 'react-cookie';

class LearnMoreInline extends Component {
  constructor (props) {
    super(props);
    this.state = {
      url: `${process.env.REACT_APP_API_URL}/services/plan`,
      area: props.area,
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
      county: this.props.Location,
      marketingSource: '',
      formErrors: {},
      success: false,
      submitting: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount () {
    const cookies = new Cookies();
    const MarketingCampaignSource = (cookies.get('CDPHP_Marketing_Campaign_Source')) ? cookies.get('CDPHP_Marketing_Campaign_Source') : 'Not Set';
    this.setState({
      marketingSource: MarketingCampaignSource
    });
  }

  getLeadSource = () => {
    let fieldValues, kids;
    fieldValues = this.props.details;
    kids = fieldValues['KidsCount'];
    console.log(fieldValues);

    console.log('KIDS: ' + kids);

    switch (this.props.area) {
      case 'MedicaidCHP':
        return 'funnel_consumer_quote_medicaid_and_chp';
        break;
      case 'MedicaidOnly':
        return 'funnel_consumer_quote_medicaid';
        break;
      case 'CHPOnlyResult':
        return 'funnel_consumer_quote_chp';
        break;
    }
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit = (event) => {
    const LeadSource = this.getLeadSource();

    event.preventDefault();
    const formResults = {
      'area': this.state.area,
      'first_name': this.state.first_name,
      'last_name': this.state.last_name,
      'email': this.state.email,
      'phone': this.state.phone,
      'County__c': this.props.details.Location.loc.County,
      'details': this.props.details,
      'Lead_Source__c': LeadSource,
      'Campaign__c': this.state.marketingSource.leadCampaign,
      'Content__c': this.state.marketingSource.leadContent,
      'Medium__c': this.state.marketingSource.leadMedium,
      'Source__c': this.state.marketingSource.leadSource,
      'GCLID__c': this.state.marketingSource.leadGCLID
    };
    console.log(formResults);

    const errors = this.validateForm(formResults);
    const isDisabled = Object.keys(errors).some(x => errors[x]);

    if (!isDisabled) {
      this.setState({submitting: true});

      axios.post(
        this.state.url, formResults
      ).then(response => {
        console.log(response);
        this.setState({submitting: false});
        this.setState({success: true});
        this.resetForm();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formID': 'Plans Microsite - ' + this.state.area + ' Lead'
        });
      }).catch(error => {
        console.log('Error Message: ' + error);
      });
    } else {
      this.setState({formErrors: errors});
    }
  }

  validateForm = (formResults) => {
    let formErrors = {};

    if (formResults.first_name.length < 2) {
      formErrors.first_name = 'Required';
    }

    if (formResults.last_name.length < 2) {
      formErrors.last_name = 'Required';
    }
    if (this.props.type === 'biz') {
      if (formResults.company.length < 2) {
        formErrors.company = 'Required';
      }
    }
    if (!formResults.phone || formResults.phone.length < 10) {
      formErrors.phone = 'Required';
    } else if (!/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(formResults.phone)) {
      formErrors.phone = 'Invalid phone number';
    }

    if (!formResults.email) {
      formErrors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formResults.email)) {
      formErrors.email = 'Invalid email address';
    }
    return formErrors;
  }

    resetForm = () => {
      console.log('here');
      this.setState({
        formErrors: {},
        first_name: '',
        last_name: '',
        phone: '',
        email: ''
        // success: false,
      });
    }

    render () {
      let Success = null;
      if (this.state.success) {
        Success = (<div id='success' className={this.state.success ? 'show' : ''}>
          <div>
            <h4>Thanks!</h4>
            <p>A sales representative will be in touch.</p>
          </div>
        </div>);
      }

      // console.log(this.state.county);
      // console.log(formResults);
      // console.log(this.props.details);

      return (
        <section className='inlineForm'>
          <div className='wrap sm text-center'>
            <div className={this.state.submitting ? ' loading' : ''}>
              <form onSubmit={this.handleSubmit}>
                <p>
                  <label>My name is</label>
                  <span className='inputContainer'>
                    <input
                      name='first_name'
                      id='first_name'
                      type='text'
                      placeholder='First'
                      className={'first_name ' + (this.state.formErrors.first_name ? 'error' : '')}
                      value={this.state.first_name}
                      onChange={this.handleInputChange} />
                  </span>
                  <span className='inputContainer'>
                    <input
                      name='last_name'
                      id='last_name'
                      type='text'
                      placeholder='Last'
                      className={'last_name ' + (this.state.formErrors.last_name ? 'error' : '')}
                      value={this.state.last_name}
                      onChange={this.handleInputChange} />
                  </span>
                </p>
                <p>
                  <label>My phone number is</label>
                  <NumberFormat
                    format='(###) ###-####'
                    mask='_'
                    name='phone'
                    id='phone'
                    type='tel'
                    placeholder='(XXX) XXX-XXXX'
                    className={'phone ' + (this.state.formErrors.phone ? 'error' : '')}
                    value={this.state.phone}
                    onChange={this.handleInputChange}
                  />
                </p>
                <p>
                  <label>My email address is</label>
                  <input
                    name='email'
                    id='email'
                    type='text'
                    className={'email ' + (this.state.formErrors.email ? 'error' : '')}
                    placeholder='you@here.com'
                    value={this.state.email}
                    onChange={this.handleInputChange} />
                </p>

                <p className='pardot_extra_field'>
                  <label htmlFor='pardot_extra_field'>Comments</label>
                  <input type='text' id='pardot_extra_field' name='pardot_extra_field' />
                </p>

                <p className='submitForm'>
                  <input type='submit' value='Contact Me' className='btn' />
                  <em className='desc'>We respect your privacy and will never<br /> share your personal information.</em>
                </p>
              </form>
              {Success}
            </div>
          </div>

        </section>
      );
    }
}

export default LearnMoreInline;
